import { render, staticRenderFns } from "./DetailPriceHomeWhite.vue?vue&type=template&id=f7ceb324&scoped=true"
import script from "./DetailPriceHomeWhite.vue?vue&type=script&lang=js"
export * from "./DetailPriceHomeWhite.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceHomeWhite.vue?vue&type=style&index=0&id=f7ceb324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ceb324",
  null
  
)

export default component.exports